export interface RefObject<T> {
  current: T | null | undefined;
}
